import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnCX: CultureInfo = {
  name: 'en-CX',
  displayName: 'English (Christmas Island)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-CX',
  parent: CultureInfoEn
};
